import GiftError from './GiftError';

export default GiftError;
